import statusTagView from './statusTagView.html';
import './statusTag.scss';
class StatusTagController {
    constructor() {
    }
}
export const StatusTagComponent = {
    template: statusTagView,
    controller: StatusTagController,
    controllerAs: '$ctrl',
    transclude: false,
    bindings: {
        statusStyle: '@',
        label: '@',
        tooltipText: '@',
    },
};
